export const dataDisplayCustomizations = {
  MuiTypography: {
    styleOverrides: {
      root: {
        fontFamily: 'Roboto, sans-serif',
      },
    },
  },
};
